import { CartUpdateEvent, ThemeEvents } from './events.js';

// Real product photos, keyed by "Size|Case Finish|Band Style|Band Color"
// (Ultra Link additionally has a case-agnostic "Size|Ultra Link|Band Color"
// fallback for sizes where we only have one photo per band color).
// Shopify's native variant->image linkage is broken for most of the 56 real
// variants, so the configurator never relies on it - it always looks up here.
const IMAGE_MAP = {
  'Small|Natural Steel|Magnetic Fabric|Charcoal': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-graphite-steel_0b1c6c00-e063-484c-af7a-ffce32392ccb.jpg?v=1788425590',
  'Small|Gold Plated|Magnetic Fabric|Charcoal': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-graphite-gold_48aff65b-ed87-474a-86a2-13a7ac8fd23c.jpg?v=1788425590',
  'Small|Natural Steel|Magnetic Fabric|Forest Green': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-forest-steel_146658b4-6a18-4f76-9cf9-b577db1bad4f.jpg?v=1788425590',
  'Small|Gold Plated|Magnetic Fabric|Forest Green': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-forest-gold_e3db96e4-345b-463f-9c7e-97af1e5d7c88.jpg?v=1788425590',
  'Small|Natural Steel|Magnetic Fabric|Ocean Blue': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-ocean-steel_6563faba-0d97-413b-ba7b-c0b88953460d.jpg?v=1788425590',
  'Small|Gold Plated|Magnetic Fabric|Ocean Blue': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-ocean-gold_2bd28668-f393-40ed-89a7-abf7e5af45ec.jpg?v=1788425590',
  'Small|Natural Steel|Magnetic Fabric|Light Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-light-steel_4d858e53-6130-42ad-9a90-cd4b4ef38279.jpg?v=1788425590',
  'Small|Gold Plated|Magnetic Fabric|Light Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-light-gold_c57c3417-2e84-413e-a53f-c03c31774c59.jpg?v=1788425590',
  'Small|Natural Steel|Magnetic Fabric|Dark Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-dark-steel_e03116a5-cec1-4187-ad51-e1f49b89899e.jpg?v=1788425590',
  'Small|Gold Plated|Magnetic Fabric|Dark Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/fabric-dark-gold_b3f29c90-6fe1-41ce-ac21-8cc03c4ce01e.jpg?v=1788425590',
  'Small|Natural Steel|Sculpted Rubber|Onyx Black': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-graphite-steel_02f0e533-ac61-4bf8-8716-6d3ba362e794.jpg?v=1788425590',
  'Small|Gold Plated|Sculpted Rubber|Onyx Black': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-graphite-gold_a6f48009-081e-430b-b383-484d7b50397a.jpg?v=1788425590',
  'Small|Natural Steel|Sculpted Rubber|Classic Blue': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-ocean-steel_23e96607-fe79-4ee8-ab2f-bcde1c1e5c9f.jpg?v=1788425590',
  'Small|Gold Plated|Sculpted Rubber|Classic Blue': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-ocean-gold_cd09704b-7f24-4ab9-808b-d5f09a80abfa.jpg?v=1788425590',
  'Small|Natural Steel|Sculpted Rubber|Forest Green': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-forest-steel_70a462ee-577b-4970-9c5c-b4da8eafb519.jpg?v=1788425590',
  'Small|Gold Plated|Sculpted Rubber|Forest Green': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-forest-gold_7a8bb6ec-bec3-4247-86bf-2b8e6fe0357f.jpg?v=1788425590',
  'Small|Natural Steel|Sculpted Rubber|Light Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-light-steel_dd7ab057-a81e-45a2-877d-3d0c407b4b37.jpg?v=1788425590',
  'Small|Gold Plated|Sculpted Rubber|Light Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-light-gold_d0b3ca67-042e-4bca-bdf3-93291f0a9379.jpg?v=1788425590',
  'Small|Natural Steel|Sculpted Rubber|Dark Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-dark-steel_434f80af-8b6f-4b0b-a11f-a282fdfa286e.jpg?v=1788425590',
  'Small|Gold Plated|Sculpted Rubber|Dark Taupe': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/rubber-dark-gold_6a7c3b37-0732-4c94-a03e-cb15e69f867b.jpg?v=1788425590',
  'Small|Natural Steel|Genuine Leather|Onyx Black': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/leather-black-steel_d401f520-b22c-44c9-90f1-b62fbe006d4c.jpg?v=1788425590',
  'Small|Gold Plated|Genuine Leather|Onyx Black': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/leather-black-gold_5416dc16-5508-44d7-948e-2f866605d26d.jpg?v=1788425590',
  'Small|Natural Steel|Genuine Leather|Saddle Brown': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/leather-brown-steel_d5642e29-4a78-4cdf-93a9-d5b680f5e9ca.jpg?v=1788425590',
  'Small|Gold Plated|Genuine Leather|Saddle Brown': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/leather-brown-gold_55b5d5d9-2643-45b5-ba0a-847a8c2f2307.jpg?v=1788425590',
  'Small|Ultra Link|Stainless Steel': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/metal-steel_49202e3c-8a59-4e29-a68e-d4976134d16f.jpg?v=1788425590',
  'Small|Ultra Link|Gold Plated': 'https://cdn.shopify.com/s/files/1/0980/8592/9266/files/metal-gold_16368484-f349-462d-9f53-808e9b5b297e.jpg?v=1788425590',

  // Large — sourced separately (Lovable's photography has a distinct Large-size shoot).
  'Large|Natural Steel|Magnetic Fabric|Charcoal': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/693afae7-7a99-4bab-a9b8-165f692a4fcb/fabric-graphite-steel.jpg',
  'Large|Gold Plated|Magnetic Fabric|Charcoal': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/a5614eb8-c162-4403-8620-656c0429da74/fabric-graphite-gold.jpg',
  'Large|Natural Steel|Magnetic Fabric|Forest Green': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/3c1fe92a-1a3c-455c-ac1a-3fc605dc8809/fabric-forest-steel.jpg',
  'Large|Gold Plated|Magnetic Fabric|Forest Green': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/b563337b-5ea4-4f50-8dd2-eb25d6a5b027/fabric-forest-gold.jpg',
  'Large|Natural Steel|Magnetic Fabric|Ocean Blue': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/fdd5092f-6db6-454e-b8d6-b32a57ddfb24/fabric-ocean-steel.jpg',
  'Large|Gold Plated|Magnetic Fabric|Ocean Blue': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/62ddbbd3-b618-4dd8-85df-9241af0efc55/fabric-ocean-gold.jpg',
  'Large|Natural Steel|Magnetic Fabric|Light Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/776d9dee-6906-4d0c-a794-20b90707323a/fabric-light-steel.jpg',
  'Large|Gold Plated|Magnetic Fabric|Light Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/8488a55e-d1ee-4b47-bf15-5a657d4b73aa/fabric-light-gold.jpg',
  'Large|Natural Steel|Magnetic Fabric|Dark Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/44c84756-d826-43e4-b6e5-a5749d854396/fabric-dark-steel.jpg',
  'Large|Gold Plated|Magnetic Fabric|Dark Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/3f39a08f-35d4-46aa-ac9d-1e6a43da8822/fabric-dark-gold.jpg',
  'Large|Natural Steel|Sculpted Rubber|Onyx Black': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/256242fe-470b-4f33-bd8e-9fd5328dd636/rubber-graphite-steel.jpg',
  'Large|Gold Plated|Sculpted Rubber|Onyx Black': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/924cacf9-5c76-4cdf-83a3-15fe56d508f2/rubber-graphite-gold.jpg',
  'Large|Natural Steel|Sculpted Rubber|Classic Blue': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/7c8b80ed-2dcd-456b-8d0a-2502f22efa4f/rubber-ocean-steel.jpg',
  'Large|Gold Plated|Sculpted Rubber|Classic Blue': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/9a2bf3a6-54aa-4767-8002-500a0635d29c/rubber-ocean-gold.jpg',
  'Large|Natural Steel|Sculpted Rubber|Forest Green': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/195cb75a-3102-41f3-b831-36b984eae129/rubber-forest-steel.jpg',
  'Large|Gold Plated|Sculpted Rubber|Forest Green': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/44acac17-f941-4714-8764-e019ee3c7ab3/rubber-forest-gold.jpg',
  'Large|Natural Steel|Sculpted Rubber|Light Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/83ae642d-5495-47ef-aee0-df4961d73959/rubber-light-steel.jpg',
  'Large|Gold Plated|Sculpted Rubber|Light Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/e9c40a8a-9aca-45c8-a537-f0e55f770b3e/rubber-light-gold.jpg',
  'Large|Natural Steel|Sculpted Rubber|Dark Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/82169461-00b6-44e3-b19d-c1192349fd22/rubber-dark-steel.jpg',
  'Large|Gold Plated|Sculpted Rubber|Dark Taupe': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/c95a65e6-39b4-4b04-9396-403e6f6c5357/rubber-dark-gold.jpg',
  'Large|Natural Steel|Genuine Leather|Onyx Black': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/6735db97-4d04-4f34-82ce-1d2cd4cda337/leather-black-steel.jpg',
  'Large|Gold Plated|Genuine Leather|Onyx Black': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/28780556-540a-44ff-8013-944a257e4d7a/leather-black-gold.jpg',
  'Large|Natural Steel|Genuine Leather|Saddle Brown': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/cc72eca5-2379-4f88-9a20-8f013ce7fb19/leather-brown-steel.jpg',
  'Large|Gold Plated|Genuine Leather|Saddle Brown': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/2824ea18-15e6-42e1-af20-5c74f5621c40/leather-brown-gold.jpg',
  'Large|Natural Steel|Ultra Link|Stainless Steel': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/e0015271-701c-415b-878a-c1dc70d8e338/metal-steel.jpg',
  'Large|Gold Plated|Ultra Link|Gold Plated': 'https://panther-reserve-launch.lovable.app/__l5e/assets-v1/410fe06a-6511-4dee-b869-381887e0c395/metal-gold.jpg',
  'Large|Gold Plated|Ultra Link|Stainless Steel': 'https://panther-reserve-launch.lovable.app/assets/metal-gold-steel-lAfg1r86.jpg',
  'Large|Natural Steel|Ultra Link|Gold Plated': 'https://panther-reserve-launch.lovable.app/assets/metal-steel-gold-BhmX0gjQ.jpg',
};

// Per-option description copy, matching the Lovable presale design exactly.
const DESCRIPTIONS = {
  'Small (40mm)': '40mm case · 2mm lugs',
  'Large (44mm)': '44mm case · 2mm lugs',
  'Natural Steel': '316L Stainless Steel',
  'Gold Plated': '18K Real Gold Plating',
  'Magnetic Fabric': 'Soft woven fabric with magnetic closure.',
  'Sculpted Rubber': 'High-performance sculpted fluoroelastomer.',
  'Genuine Leather': 'Full-grain leather with magnetic closure.',
  'Ultra Link': 'Precision stainless steel mesh. Gold finish available.',
};

// Real swatch colors, matching the Lovable presale design exactly.
const COLOR_MAP = {
  'Natural Steel': '#c9cdd4',
  'Gold Plated': '#c9a56b',
  'Charcoal': '#2f3740',
  'Forest Green': '#2e3d38',
  'Ocean Blue': '#354c54',
  'Light Taupe': '#d9d4cd',
  'Dark Taupe': '#8b8178',
  'Onyx Black': '#1a1a1a',
  'Classic Blue': '#3b5578',
  'Saddle Brown': '#8b5a2b',
  'Stainless Steel': '#a8a29a',
};

const BAND_SEPARATOR = ' – '; // " – " (en dash), matches Shopify's literal option value format.
const MAX_QUANTITY = 4;

// Pre-order messaging (image badge, banner above the options, button label, the
// note under the button and the "Pre-order" line item property that carries it
// into the cart and checkout all read from here). Set `enabled: false` once the
// Solstice is shipping to go back to a normal "Add to Cart" page. The cart
// notice (snippets/solstice-preorder-note.liquid) reads its text from that line
// item property, so changing `shipsText` here updates it too.
const PREORDER = {
  enabled: true,
  buttonLabel: 'Pre-Order',
  headline: 'Pre-order now',
  shipsText: 'Ships the first week of December',
};
const CTA_LABEL = PREORDER.enabled ? PREORDER.buttonLabel : 'Add to Cart';

function readJSON(id) {
  const el = document.getElementById(id);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function optionIndex(product, name) {
  return product.options.indexOf(name);
}

function uniqueInOrder(values) {
  const seen = new Set();
  const out = [];
  for (const v of values) {
    if (!seen.has(v)) {
      seen.add(v);
      out.push(v);
    }
  }
  return out;
}

function splitBandValue(value) {
  const idx = value.indexOf(BAND_SEPARATOR);
  if (idx === -1) return { style: value, color: '' };
  return { style: value.slice(0, idx), color: value.slice(idx + BAND_SEPARATOR.length) };
}

/** Builds { styleName: [colorName, ...] } from a product's Band-like option. */
function buildBandMap(product, bandOptionName) {
  const idx = optionIndex(product, bandOptionName);
  const values = uniqueInOrder(product.variants.map((v) => v.options[idx]));
  const map = {};
  const order = [];
  for (const value of values) {
    const { style, color } = splitBandValue(value);
    if (!map[style]) {
      map[style] = [];
      order.push(style);
    }
    if (color && !map[style].includes(color)) map[style].push(color);
  }
  return { map, order, optionIndex: idx };
}

function findVariant(product, selections) {
  return product.variants.find((v) => product.options.every((name, i) => v.options[i] === selections[name]));
}

function minPriceWhere(product, predicate) {
  const prices = product.variants.filter(predicate).map((v) => v.price);
  return prices.length ? Math.min(...prices) : null;
}

/** "Small (40mm)" -> "Small", "Large (44mm)" -> "Large" */
function sizeShortLabel(value) {
  const idx = value.indexOf(' (');
  return idx === -1 ? value : value.slice(0, idx);
}

function imageKeyFor(size, caseFinish, bandStyle, bandColor) {
  const shortSize = sizeShortLabel(size);
  if (bandStyle === 'Ultra Link') {
    return `${shortSize}|${caseFinish}|Ultra Link|${bandColor}`;
  }
  return `${shortSize}|${caseFinish}|${bandStyle}|${bandColor}`;
}

class SolsticeConfigurator {
  constructor(root) {
    this.root = root;
    this.currency = root.dataset.currency || 'USD';
    this.product = readJSON('solstice-product-json');
    this.pantherCareProduct = readJSON('solstice-panther-care-json');
    this.extraBandProduct = readJSON('solstice-extra-band-json');
    this.imageEl = document.getElementById('solstice-media__image');
    this.captionEl = document.getElementById('solstice-media__caption');
    this.stickyBarEl = document.querySelector('.solstice-sticky-bar');
    this.stickyBarImageEl = document.getElementById('solstice-sticky-bar__image');
    this.stickyBarTextEl = document.getElementById('solstice-sticky-bar__text');

    const badgeEl = document.getElementById('solstice-media__badge');
    if (badgeEl && PREORDER.enabled) {
      badgeEl.textContent = `Pre-order · ${PREORDER.shipsText}`;
      badgeEl.hidden = false;
    }

    if (!this.product || !this.product.variants || !this.product.variants.length) {
      root.innerHTML = '<p>This product is currently unavailable.</p>';
      return;
    }

    this.sizeIdx = optionIndex(this.product, 'Case Size');
    this.finishIdx = optionIndex(this.product, 'Case Finish');
    this.bandName = this.product.options.includes('Band') ? 'Band' : this.product.options[this.product.options.length - 1];
    const band = buildBandMap(this.product, this.bandName);
    this.bandMap = band.map;
    this.bandStyles = band.order;
    this.bandIdx = band.optionIndex;

    this.sizes = uniqueInOrder(this.product.variants.map((v) => v.options[this.sizeIdx]));
    this.finishes = uniqueInOrder(this.product.variants.map((v) => v.options[this.finishIdx]));

    if (this.extraBandProduct && this.extraBandProduct.variants) {
      const extraBandOptionName = this.extraBandProduct.options[0];
      const extraBand = buildBandMap(this.extraBandProduct, extraBandOptionName);
      this.extraBandMap = extraBand.map;
      this.extraBandStyles = extraBand.order;
      this.extraBandOptionName = extraBandOptionName;
    }

    this.globalMinPrice = Math.min(...this.product.variants.map((v) => v.price));

    this.state = {
      size: this.sizes[0],
      finish: this.finishes[0],
      bandStyle: this.bandStyles[0],
      bandColor: this.bandMap[this.bandStyles[0]][0],
      pantherCare: false,
      extraBands: [], // [{ style, color, variantId, price }]
      extraBandStyleView: null,
      quantity: 1,
    };

    this.root.addEventListener('click', (e) => this.handleClick(e));
    this.render();
    this.updateImage();
    this.syncMediaHeight();
    this.initMobileStickyBar();
  }

  /**
   * The mobile sticky bar (thumbnail + selection text) should only appear
   * once the big hero image has scrolled out of view - never while it's
   * still on screen - and should disappear again once the customer has
   * scrolled past the whole configurator. It's `position: fixed` (see CSS),
   * so plain CSS `position: sticky` can't drive this; instead we compare
   * the hero image's and the configurator root's viewport positions on
   * scroll/resize and toggle a class. Desktop/tablet never show it at all
   * (CSS keeps it display:none there), this only runs the check on mobile.
   */
  initMobileStickyBar() {
    if (!this.stickyBarEl || !this.imageEl) return;
    const mq = window.matchMedia('(max-width: 749px)');
    const update = () => {
      if (!mq.matches) {
        this.stickyBarEl.classList.remove('is-visible');
        return;
      }
      const heroPassed = this.imageEl.getBoundingClientRect().bottom <= 0;
      const sectionPassed = this.root.getBoundingClientRect().bottom <= 0;
      this.stickyBarEl.classList.toggle('is-visible', heroPassed && !sectionPassed);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    mq.addEventListener('change', update);
    update();
  }

  /**
   * Horizon's grid stretches the media column to match the details column's
   * height only above certain breakpoints/contexts (e.g. not reliably inside
   * the theme editor's preview iframe). This keeps the sticky image's
   * container at least as tall as the configurator at all times, regardless
   * of that grid behavior, so the sticky effect always holds to the bottom.
   * Desktop/tablet only - on mobile the image isn't sticky at all (a small
   * sticky bar takes over that role instead), so forcing height there would
   * just leave a large empty gap.
   */
  syncMediaHeight() {
    const mediaEl = document.querySelector('.solstice-media');
    if (!mediaEl || !window.ResizeObserver) return;
    const mq = window.matchMedia('(min-width: 750px)');
    const sync = () => {
      mediaEl.style.minHeight = mq.matches ? `${this.root.offsetHeight}px` : '';
    };
    new ResizeObserver(sync).observe(this.root);
    mq.addEventListener('change', sync);
    sync();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: this.currency }).format(cents / 100);
  }

  currentVariant() {
    return findVariant(this.product, {
      'Case Size': this.state.size,
      'Case Finish': this.state.finish,
      [this.bandName]: `${this.state.bandStyle}${BAND_SEPARATOR}${this.state.bandColor}`,
    });
  }

  currentImageUrl() {
    const key = imageKeyFor(this.state.size, this.state.finish, this.state.bandStyle, this.state.bandColor);
    if (IMAGE_MAP[key]) return IMAGE_MAP[key];
    const smallFallback = imageKeyFor('Small (40mm)', this.state.finish, this.state.bandStyle, this.state.bandColor);
    return IMAGE_MAP[smallFallback] || this.product.featured_image;
  }

  currentCaption() {
    return `${this.state.size} · ${this.state.finish} · ${this.state.bandStyle} · ${this.state.bandColor}`;
  }

  updateImage() {
    const url = this.currentImageUrl();
    // Small and Large share the same source photography (same framing), so
    // a small CSS zoom on Large is the only thing that visually tells the
    // two case sizes apart in the configurator.
    const isLarge = sizeShortLabel(this.state.size) === 'Large';
    if (this.imageEl && url) {
      this.imageEl.src = url;
      this.imageEl.classList.toggle('is-large-size', isLarge);
    }
    if (this.captionEl) {
      this.captionEl.textContent = this.currentCaption();
    }
    if (this.stickyBarImageEl && url) {
      this.stickyBarImageEl.src = url;
      this.stickyBarImageEl.classList.toggle('is-large-size', isLarge);
    }
    if (this.stickyBarTextEl) {
      this.stickyBarTextEl.textContent = this.currentCaption();
    }
  }

  sizeDelta(value) {
    const min = minPriceWhere(this.product, (v) => v.options[this.sizeIdx] === value);
    return min === null ? 0 : min - this.globalMinPrice;
  }

  finishDelta(value) {
    const min = minPriceWhere(this.product, (v) => v.options[this.finishIdx] === value);
    return min === null ? 0 : min - this.globalMinPrice;
  }

  bandStyleDelta(style) {
    const min = minPriceWhere(this.product, (v) => v.options[this.bandIdx].startsWith(`${style}${BAND_SEPARATOR}`));
    return min === null ? 0 : min - this.globalMinPrice;
  }

  extraBandVariantFor(style, color) {
    if (!this.extraBandProduct) return null;
    return findVariant(this.extraBandProduct, { [this.extraBandOptionName]: `${style}${BAND_SEPARATOR}${color}` });
  }

  handleClick(e) {
    const el = e.target.closest('[data-action]');
    if (!el) return;
    const action = el.dataset.action;
    let imageAffected = true;

    if (action === 'select-size') this.state.size = el.dataset.value;
    else if (action === 'select-finish') this.state.finish = el.dataset.value;
    else if (action === 'select-band-style') {
      this.state.bandStyle = el.dataset.value;
      const colors = this.bandMap[this.state.bandStyle] || [];
      if (!colors.includes(this.state.bandColor)) this.state.bandColor = colors[0];
    } else if (action === 'select-band-color') this.state.bandColor = el.dataset.value;
    else if (action === 'select-panther-care') {
      this.state.pantherCare = el.dataset.value === 'yes';
      imageAffected = false;
    } else if (action === 'view-extra-band-style') {
      this.state.extraBandStyleView = el.dataset.value;
      imageAffected = false;
    } else if (action === 'toggle-extra-band-color') {
      this.toggleExtraBand(this.state.extraBandStyleView, el.dataset.value);
      imageAffected = false;
    } else if (action === 'clear-extra-bands') {
      this.state.extraBands = [];
      this.state.extraBandStyleView = null;
      imageAffected = false;
    } else if (action === 'remove-extra-band') {
      this.removeExtraBand(Number(el.dataset.index));
      imageAffected = false;
    } else if (action === 'qty-decrement') {
      this.state.quantity = Math.max(1, this.state.quantity - 1);
      imageAffected = false;
    } else if (action === 'qty-increment') {
      this.state.quantity = Math.min(MAX_QUANTITY, this.state.quantity + 1);
      imageAffected = false;
    } else if (action === 'add-to-cart') {
      this.addToCart(el);
      return;
    } else return;

    this.render();
    if (imageAffected) this.updateImage();
  }

  toggleExtraBand(style, color) {
    const variant = this.extraBandVariantFor(style, color);
    if (!variant) return;
    const existingIndex = this.state.extraBands.findIndex((b) => b.variantId === variant.id);
    if (existingIndex !== -1) {
      this.state.extraBands.splice(existingIndex, 1);
    } else {
      this.state.extraBands.push({ style, color, variantId: variant.id, price: variant.price });
    }
  }

  removeExtraBand(index) {
    this.state.extraBands.splice(index, 1);
  }

  total() {
    const variant = this.currentVariant();
    let total = variant ? variant.price * this.state.quantity : 0;
    if (this.state.pantherCare && this.pantherCareProduct?.variants?.[0]) {
      total += this.pantherCareProduct.variants[0].price;
    }
    for (const band of this.state.extraBands) total += band.price;
    return total;
  }

  async addToCart(button) {
    const variant = this.currentVariant();
    if (!variant || !variant.available) return;

    // The "Pre-order" line item property is what carries the shipping note into
    // the cart page and checkout (and onto the order) for the watch line.
    const watchItem = { id: variant.id, quantity: this.state.quantity };
    if (PREORDER.enabled) watchItem.properties = { 'Pre-order': PREORDER.shipsText };
    const items = [watchItem];
    if (this.state.pantherCare && this.pantherCareProduct?.variants?.[0]) {
      items.push({ id: this.pantherCareProduct.variants[0].id, quantity: 1 });
    }
    for (const band of this.state.extraBands) {
      items.push({ id: band.variantId, quantity: 1 });
    }

    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!res.ok) throw new Error(`Cart add failed (${res.status})`);
      await res.json();

      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();
      document.dispatchEvent(
        new CartUpdateEvent(cart, 'solstice-configurator', { source: 'solstice-configurator', itemCount: cart.item_count })
      );

      button.textContent = 'Added';
      setTimeout(() => {
        button.disabled = false;
        button.textContent = CTA_LABEL;
      }, 1800);
    } catch (err) {
      console.error('Solstice configurator: add to cart failed', err);
      button.disabled = false;
      button.textContent = CTA_LABEL;
    }
  }

  optionButton(action, value, label, delta, selected, { description, dotColor } = {}) {
    const deltaLabel = delta > 0 ? `+${this.formatMoney(delta)}` : delta < 0 ? `-${this.formatMoney(-delta)}` : '';
    return `
      <button type="button" class="solstice-option${selected ? ' is-selected' : ''}" data-action="${action}" data-value="${value}">
        <span class="solstice-option__text">
          ${dotColor ? `<span class="solstice-option__dot" style="background:${dotColor}"></span>` : ''}
          <span class="solstice-option__label">${label}</span>
        </span>
        ${deltaLabel ? `<span class="solstice-option__delta">${deltaLabel}</span>` : ''}
        ${description ? `<span class="solstice-option__desc">${description}</span>` : ''}
      </button>
    `;
  }

  swatchButton(action, value, label, selected) {
    const color = COLOR_MAP[value] || '';
    return `
      <button type="button" class="solstice-swatch${selected ? ' is-selected' : ''}" data-action="${action}" data-value="${value}">
        <span class="solstice-swatch__dot" style="${color ? `background:${color}` : ''}"></span>
        <span class="solstice-swatch__label">${label}</span>
      </button>
    `;
  }

  step(index, title, selectedText, bodyHtml, { grid } = {}) {
    return `
      <section class="solstice-step">
        <div class="solstice-step__head">
          <span class="solstice-step__index">${index}</span>
          <h3 class="solstice-step__title">${title}</h3>
          <span class="solstice-step__selected">${selectedText}</span>
        </div>
        <div class="solstice-options${grid ? ' solstice-options--grid' : ''}">${bodyHtml}</div>
      </section>
    `;
  }

  render() {
    const variant = this.currentVariant();
    const total = this.total();
    // The $200 discount is a compare-at price on every variant, so the "was"
    // price / savings only show when the selected variant actually has one.
    const unitSavings = variant && variant.compare_at_price > variant.price ? variant.compare_at_price - variant.price : 0;

    const sizeStep = this.step(
      '01',
      'Case Size',
      this.state.size,
      this.sizes
        .map((v) =>
          this.optionButton('select-size', v, sizeShortLabel(v), this.sizeDelta(v), v === this.state.size, {
            description: DESCRIPTIONS[v],
          })
        )
        .join(''),
      { grid: true }
    );

    const finishStep = this.step(
      '02',
      'Case Finish',
      this.state.finish,
      this.finishes
        .map((v) =>
          this.optionButton('select-finish', v, v, this.finishDelta(v), v === this.state.finish, {
            description: DESCRIPTIONS[v],
            dotColor: COLOR_MAP[v],
          })
        )
        .join(''),
      { grid: true }
    );

    const bandStyleStep = this.step(
      '03',
      'Band Style',
      this.state.bandStyle,
      this.bandStyles
        .map((v) =>
          this.optionButton('select-band-style', v, v, this.bandStyleDelta(v), v === this.state.bandStyle, {
            description: DESCRIPTIONS[v],
          })
        )
        .join('')
    );

    const colors = this.bandMap[this.state.bandStyle] || [];
    const bandColorStep = this.step(
      '04',
      'Band Color',
      this.state.bandColor,
      `<div class="solstice-swatch-grid" style="grid-template-columns: repeat(${colors.length}, 1fr);">${colors
        .map((c) => this.swatchButton('select-band-color', c, c, c === this.state.bandColor))
        .join('')}</div>`
    );

    const careVariant = this.pantherCareProduct?.variants?.[0];
    const careStep = careVariant
      ? this.step(
          '05',
          'Panther Care',
          this.state.pantherCare ? 'Added' : 'No coverage',
          this.optionButton('select-panther-care', 'yes', 'Add Panther Care', careVariant.price, this.state.pantherCare) +
            this.optionButton('select-panther-care', 'no', 'No coverage', 0, !this.state.pantherCare),
          { grid: true }
        )
      : '';

    let extraBandStep = '';
    if (this.extraBandProduct && this.extraBandStyles) {
      const viewColors = this.state.extraBandStyleView ? this.extraBandMap[this.state.extraBandStyleView] || [] : [];
      const noneAdded = this.state.extraBands.length === 0;
      // "No Extra Bands" only shows selected in the untouched default state -
      // once the customer starts browsing a style's colors, it deselects so
      // only one option is ever highlighted at a time, even though nothing
      // has been added yet.
      const noneButtonSelected = noneAdded && !this.state.extraBandStyleView;
      const rows = this.state.extraBands
        .map(
          (b, i) => `
        <div class="solstice-extra-band-row">
          <span>${b.style} – ${b.color}</span>
          <span>${this.formatMoney(b.price)}</span>
          <button type="button" class="solstice-remove" data-action="remove-extra-band" data-index="${i}" aria-label="Remove">×</button>
        </div>
      `
        )
        .join('');

      extraBandStep = this.step(
        '06',
        'Extra Bands',
        noneAdded ? 'No Extra Bands' : `${this.state.extraBands.length} added`,
        `
          <div class="solstice-extra-band-picker">
            ${this.optionButton('clear-extra-bands', 'none', 'No Extra Bands', 0, noneButtonSelected)}
            <div class="solstice-options">
              ${this.extraBandStyles
                .map((v) => this.optionButton('view-extra-band-style', v, v, 0, v === this.state.extraBandStyleView))
                .join('')}
            </div>
            ${
              viewColors.length
                ? `<div class="solstice-swatch-grid" style="grid-template-columns: repeat(${viewColors.length}, 1fr);">
              ${viewColors
                .map((c) =>
                  this.swatchButton(
                    'toggle-extra-band-color',
                    c,
                    c,
                    this.state.extraBands.some((b) => b.style === this.state.extraBandStyleView && b.color === c)
                  )
                )
                .join('')}
            </div>`
                : ''
            }
          </div>
          ${rows ? `<div class="solstice-extra-band-list">${rows}</div>` : ''}
        `
      );
    }

    const summaryLines = [
      `<div class="solstice-summary-line"><span>${this.state.size} / ${this.state.finish} / ${this.state.bandStyle} – ${this.state.bandColor}${this.state.quantity > 1 ? ` × ${this.state.quantity}` : ''}</span><span>${variant ? `${unitSavings ? `<s class="solstice-compare">${this.formatMoney(variant.compare_at_price * this.state.quantity)}</s>` : ''}${this.formatMoney(variant.price * this.state.quantity)}` : '—'}</span></div>`,
    ];
    if (unitSavings) {
      summaryLines.push(
        `<div class="solstice-summary-line solstice-summary-line--savings"><span>You save</span><span>${this.formatMoney(unitSavings * this.state.quantity)}</span></div>`
      );
    }
    if (this.state.pantherCare && careVariant) {
      summaryLines.push(
        `<div class="solstice-summary-line"><span>Panther Care</span><span>${this.formatMoney(careVariant.price)}</span></div>`
      );
    }
    for (const b of this.state.extraBands) {
      summaryLines.push(
        `<div class="solstice-summary-line"><span>Extra Band – ${b.style} ${b.color}</span><span>${this.formatMoney(b.price)}</span></div>`
      );
    }

    const available = variant ? variant.available : false;

    const preorderBanner = PREORDER.enabled
      ? `<div class="solstice-preorder">
          <span class="solstice-preorder__badge">Pre-order</span>
          <span class="solstice-preorder__text"><strong>${PREORDER.headline}.</strong>${unitSavings ? ` Save ${this.formatMoney(unitSavings)}.` : ''} ${PREORDER.shipsText}.</span>
        </div>`
      : '';
    const preorderNote = PREORDER.enabled
      ? `<p class="solstice-preorder-note">${PREORDER.shipsText}.</p>`
      : '';

    this.root.innerHTML = `
      ${preorderBanner}
      ${sizeStep}
      ${finishStep}
      ${bandStyleStep}
      ${bandColorStep}
      ${careStep}
      ${extraBandStep}
      <div class="solstice-summary">
        ${summaryLines.join('')}
        <div class="solstice-summary-total">
          <span>Total</span>
          <span>${this.formatMoney(total)}</span>
        </div>
      </div>
      <div class="solstice-buy-row">
        <div class="solstice-quantity">
          <button type="button" data-action="qty-decrement" aria-label="Decrease quantity">−</button>
          <span>${this.state.quantity}</span>
          <button type="button" data-action="qty-increment" aria-label="Increase quantity">+</button>
        </div>
        <button type="button" class="solstice-cta" data-action="add-to-cart" ${available ? '' : 'disabled'}>
          ${available ? CTA_LABEL : 'Sold out'}
        </button>
      </div>
      ${preorderNote}
    `;
  }
}

function init() {
  const root = document.getElementById('solstice-configurator');
  if (root) new SolsticeConfigurator(root);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
